import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RouteRoles } from "ui/common/router/MainRouter.types";
import RoleRoute from "ui/user/containers/RoleRoute/RoleRoute";

const PartnerPage = lazy(() => import("ui/partner/pages/PartnerPage"));
const PartnersPage = lazy(() => import("ui/partner/pages/PartnersPage"));

export enum PartnerRoutes {
    MAIN = "/partners",
    PARTNER = "/partners/:partnerAddress",
}

export const usePartnerRoutes = (): RouteObject[] => {
    return [
        {
            path: PartnerRoutes.MAIN,
            element: (
                <RoleRoute roles={RouteRoles.PARTNERS}>
                    <PartnersPage />
                </RoleRoute>
            ),
        },
        {
            path: PartnerRoutes.PARTNER,
            element: (
                <RoleRoute roles={RouteRoles.PARTNERS}>
                    <PartnerPage />
                </RoleRoute>
            ),
        },
    ];
};
